import type { TFunction } from 'i18next';

import type { CoinType } from '../stores/cointype/CoinTypeStore';

import { formatValueWithK } from './helpers';

export function formatAmountByCoinType({
  amount,
  coinType,
  t,
}: {
  amount: number;
  coinType: CoinType;
  t: TFunction;
}): string {
  return coinType === 'GC' ? formatValueWithK(amount, t) : amount.toLocaleString();
}
